import type { App } from 'vue'
import {
  init,
  replayIntegration,
  thirdPartyErrorFilterIntegration,
} from '@sentry/vue'
import { SENTRY_DSN, SENTRY_ENV } from 'src/app/config'
import { DOMAIN } from 'src/presentation/shared/config'

export function setupSentry(app: App) {
  if (!SENTRY_DSN || !SENTRY_ENV) return
  init({
    app,
    dsn: SENTRY_DSN,
    environment: SENTRY_ENV,
    integrations: [
      replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
        maskAllInputs: false,
      }),
      thirdPartyErrorFilterIntegration({
        filterKeys: ['cart-fe'],
        behaviour: 'drop-error-if-exclusively-contains-third-party-frames',
      }),
    ],
    replaysOnErrorSampleRate: 1.0,
    ignoreErrors: ['Network Error', 'timeout'],
    allowUrls: [DOMAIN],
    // Подстраховка к thirdPartyErrorFilterIntegration: отбрасываем события,
    // в стеке которых нет ни одного фрейма из нашего бандла (папка /assets/).
    // Покрывает внедрённые/сторонние скрипты и пустой стек у SyntaxError из
    // onerror — работает независимо от вшивания app-ключа и сразу после деплоя.
    beforeSend(event) {
      const exception = event.exception?.values?.[0]
      if (!exception) return event
      const frames = exception.stacktrace?.frames ?? []
      const hasAppFrame = frames.some((frame) =>
        frame.filename?.includes('/assets/'),
      )
      return hasAppFrame ? event : null
    },
  })
}
